// v3.18-1277 PWA-003 Phase 1.5 — Service worker registration.
//
// Registers /sw.js on window load if the browser supports it. Fails silently
// otherwise. Adds NO other behaviour — no update prompt UX, no cache warming,
// no messaging. The SW itself is a strict passthrough (see public/sw.js).

export function registerInstallEligibilitySW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(() => {
        // Silent failure — SW is a progressive enhancement for installability.
        // The Hub continues to function identically without it.
      });
  });
}
